// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { number, string } from 'prop-types'
import { useDispatch } from 'react-redux'
import { useBooleanToggle } from 'hooks'

import {
  copyPath,
  projectSummaryModalOpen,
} from 'redux/modules/projectSummary'

const PathMenu = ({ idRoot, pathId }) => {
  const dispatch = useDispatch()

  const [isOpen, toggleIsOpen] = useBooleanToggle(false)

  const handleCopyPath = () => {
    toggleIsOpen()
    dispatch(copyPath(pathId))
  }

  const handleDeletePath = () => {
    toggleIsOpen()
    dispatch(projectSummaryModalOpen('delete-paths', [pathId]))
  }

  const handleMouseLeave = e => {
    if (isOpen && e.target === e.currentTarget) {
      toggleIsOpen()
    }
  }

  return (
    <div
      className={'path-menu'}
      onClick={e => e.stopPropagation()}>
      <p
        id={`${idRoot}trigger`}
        className={'path-menu-toggle pointer'}
        onClick={toggleIsOpen}>
        <i
          className={`fa fa-caret-${isOpen ? 'up' : 'down'}`}
          id={`${idRoot}icon`} />
      </p>
      <ul
        className={`path-menu-list ${isOpen ? 'active' : ''}`}
        id={`${idRoot}menu`}
        onMouseLeave={handleMouseLeave}>
        <li
          id={`${idRoot}delete`}
          onClick={handleDeletePath}>{'Delete'}</li>
        <li
          id={`${idRoot}copy`}
          onClick={handleCopyPath}>{'Copy'}</li>
      </ul>
    </div>
  )
}

PathMenu.propTypes = {
  idRoot: string.isRequired,
  pathId: number.isRequired,
}

export default PathMenu
